import * as ui from './lib/ui.js';
import { initEntryForm } from './lib/entry-form.js';
import { initCampaignFaqs } from './lib/faq.js';

(function($) {

	ui.init();
	initEntryForm();
	initCampaignFaqs();

})(jQuery);
